
import { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Copy01Icon, Download01Icon, MoreVerticalIcon, PencilEdit01Icon} from "@hugeicons/core-free-icons";
import {Link} from "react-router-dom";
import {copyToClipboard} from "../../../utils/functions";
import {toast} from "react-toastify";
import {projectPath} from "../../registry-project/RegistryProjectRoute";

// flowUid: the sub project's Firebase flow, used by Copy/Download Export.
// projectId/subProjectId: the registry project, used so "Edit Project" opens its own rebuilt
// Settings page instead of the legacy flow-settings page.
export const ProjectRowMenu = ({flowUid, projectId, subProjectId}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const onCopyExport = async (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (flowUid) {
      try {
        const url = `${process.env.REACT_APP_FIREBASE_FUNCTIONS_URL}/api/apiProject/${flowUid}`
        await copyToClipboard(url);
        toast.success("URL is copied successfully.")
      } catch (e) {
        console.log(e)
        toast.error("URL failed to copy.")
      }
    }

    handleClose(event);
  }

  const onExportFile = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    // Replace with the actual API endpoint that serves the file
    const apiUrl = `${process.env.REACT_APP_FIREBASE_FUNCTIONS_URL}/api/export/${flowUid}`;

    fetch(apiUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);

        // Create an anchor element to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = `${flowUid}.json`; // Specify the desired file name
        document.body.appendChild(a);
        a.click();

        // Clean up by removing the anchor and the URL
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error downloading file: ', error);
      });

    handleClose(event);
  };


  return (
    <>
      <IconButton onClick={handleOpen} aria-label={"Project actions"} sx={{
        width: 34, height: 34, borderRadius: "50% !important", color: "#4A4A63", "&:hover": {bgcolor: "#F4F4FA"},
      }}>
        <HugeiconsIcon icon={MoreVerticalIcon} size={18}/>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              p: 1, borderRadius: 3,
            }
          }
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleClose} component={Link} to={projectPath(projectId, subProjectId, "settings")} sx={{borderRadius: 2, px: 2.5}}>
          <ListItemIcon><HugeiconsIcon icon={PencilEdit01Icon} size={18} /></ListItemIcon>
          <ListItemText>Edit Project</ListItemText>
        </MenuItem>
        <MenuItem onClick={onCopyExport} sx={{borderRadius: 2, px: 2.5}}>
          <ListItemIcon><HugeiconsIcon icon={Copy01Icon} size={18} /></ListItemIcon>
          <ListItemText>Copy Export</ListItemText>
        </MenuItem>
        <MenuItem onClick={onExportFile} sx={{borderRadius: 2, px: 2.5}}>
          <ListItemIcon><HugeiconsIcon icon={Download01Icon} size={18} /></ListItemIcon>
          <ListItemText>Download Export</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
